import { useCallback, useEffect, useState } from 'react';

import { getProductSuppliers } from './api/product-suppliers-api';
import type { ProductSupplier } from './product-suppliers-types';

type UseProductSuppliersResult = {
  suppliers: ProductSupplier[];
  isLoading: boolean;
  hasError: boolean;
  reload: () => void;
};

export const useProductSuppliers = (productId: number | null): UseProductSuppliersResult => {
  const [suppliers, setSuppliers] = useState<ProductSupplier[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);

  const load = useCallback(async () => {
    if (!productId) {
      setIsLoading(false);
      return;
    }
    setIsLoading(true);
    setHasError(false);
    try {
      const data = await getProductSuppliers(productId);
      setSuppliers(data);
    } catch {
      setHasError(true);
    } finally {
      setIsLoading(false);
    }
  }, [productId]);

  useEffect(() => {
    load();
  }, [load]);

  return { suppliers, isLoading, hasError, reload: load };
};
